module.exports = __webpack_public_path__ + "static/media/Episode_Hero_Mobile.bcebdb7e.png";